var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('game-extrastars',{attrs:{"intro-sprite":"/images/game/w2d4/w2d4_extrapoints.png","intro-text":_vm.$lang.get('w2d4.game4.stars', {br: '\n'}),"questions":[
        {
            questiontext: _vm.$lang.get('w2d4.game4.meaning'),
            bubbleText: _vm.$lang.get('w2d4.game4.remember'),
            answerFontSize: 22,
            answers: [
                {
                    option: _vm.$lang.get('w2d4.game4.climber'),
                    correct: true
                },
                {
                    option: _vm.$lang.get('w2d4.game4.spider'),
                    correct: false
                },
                {
                    option: _vm.$lang.get('w2d4.game4.ship'),
                    correct: false
                }
            ]
        },
        {
            questiontext: _vm.$lang.get('w2d4.game4.robots'),
            bubbleText: _vm.$lang.get('w2d4.game4.question2'),
            answers: [
                {
                    option: _vm.$lang.get('w2d4.game4.rocket'),
                    correct: false
                },
                {
                    option: _vm.$lang.get('w2d4.game4.earth'),
                    correct: true
                },
                {
                    option: _vm.$lang.get('w2d4.game4.alone'),
                    correct: false
                }
            ]
        }
    ]}})}
var staticRenderFns = []

export { render, staticRenderFns }